import { DocumentEventEmitter } from "../../../DocumentEventEmitter";

export class ToastService extends DocumentEventEmitter<"show-toast"> {
  show(message: string, type = "info") {
    return this.emit("show-toast", { message, type, id: new Date().getTime() });
  }
};
